// extracted by mini-css-extract-plugin
var _1 = "MinimalLayout-module__minimal___UgduV";
export { _1 as "minimal" }
